import React, { useRef } from 'react';

import Filter from './FilterSidebar';
import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import {
  CustomSorterWrapper,
  CaretIcon,
  DropDownListContainer,
  DropDownList,
  LabelAndIconContainer,
  IconContainer,
} from './styles';

export default function FilterDropdown({ type, items, selectedTags, hasFilters, clearFilters, options }) {
  const dropdownRef = useRef(null);

  const [isOpenDropdown, setIsOpenDropdown] = useDetectOutsideClick(dropdownRef, false);

  return (
    <CustomSorterWrapper
      ref={dropdownRef}
      onClick={() => {
        setIsOpenDropdown(!isOpenDropdown);
      }}
    >
      <LabelAndIconContainer>
        {selectedTags.length === 0
          ? `All ${type}`
          : selectedTags.length === 1
            ? selectedTags[0]
            : `${selectedTags[0]}, +${selectedTags.length - 1}`}
        <IconContainer>
          <CaretIcon isOpen={isOpenDropdown} icon="fa-solid fa-chevron-down" />
        </IconContainer>
      </LabelAndIconContainer>
      {isOpenDropdown && (
        <DropDownListContainer>
          <DropDownList>
            <Filter items={items} hasFilters={hasFilters} clearFilters={clearFilters} options={options} />
          </DropDownList>
        </DropDownListContainer>
      )}
    </CustomSorterWrapper>
  );
}
